// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
export type StatsTopAddonFieldsFragment = { __typename?: 'RestaurantStats', topAddons: Array<{ __typename?: 'ItemStats', amount: number, name: string, quantity: number }> };

export const StatsTopAddonFieldsFragmentDoc = gql`
    fragment statsTopAddonFields on RestaurantStats {
  topAddons {
    amount
    name
    quantity
  }
}
    `;